<template>
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <v-flex xs12 class="mb-5">
          <h4>{{ pageTitle }}</h4>
        </v-flex>
        <v-flex xs12>
          <v-form ref="form" lazy-validation @submit.prevent="submit">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="name"
                    name="name"
                    label="Name"
                    :counter="50"
                    v-validate="'required|max:50'"
                    data-vv-as="Name"
                    :error-messages="errors.collect('name')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="email"
                    name="email"
                    label="Email"
                    :counter="50"
                    v-validate="'max:50'"
                    data-vv-as="Email"
                    :error-messages="errors.collect('email')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-select
                    v-model="rating"
                    :items="ratingList"
                    name="rating"
                    label="Rating"
                    v-validate="'required'"
                    data-vv-as="Rating"
                    :error-messages="errors.collect('rating')"
                    item-text="name"
                    item-value="id"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md3>
                  <v-select
                    v-model="status"
                    :items="statusList"
                    name="status"
                    label="Status"
                    v-validate="'required'"
                    data-vv-as="Status"
                    :error-messages="errors.collect('status')"
                    item-text="name"
                    item-value="id"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md12>
                  <v-textarea
                    v-model="review"
                    name="review"
                    label="Review"
                    :counter="1000"
                    v-validate="'required|max:1000'"
                    data-vv-as="Review"
                    :error-messages="errors.collect('review')"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 md1>
                  <v-btn color="info" type="button" @click="imagePicked">
                    <v-icon>cloud_upload</v-icon>Image
                  </v-btn>
                  <input
                    type="file"
                    style="display: none"
                    ref="ImageUploader"
                    accept="image/*"
                    @change="onImagePicked"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <vue-cropper
                    ref="cropper"
                    :aspect-ratio="ratio"
                    :src="mainImage"
                    alt="Upload Image"
                  ></vue-cropper>
                  <!-- <img :src="image" style="width:100%" v-if="image" /> -->
                  <br />
                  <v-btn color="info" type="button" @click="crop" v-if="showCrop">
                    <v-icon>crop</v-icon>Crop
                  </v-btn>
                </v-flex>
                <v-flex xs12 md4>
                  <img v-if="image" :src="image" alt="Cropped Image" style="width:100%" />
                </v-flex>
              </v-layout>
            </v-container>
            <v-divider class="mt-5"></v-divider>
            <v-card-actions>
              <v-btn color="success" type="submit">
                <v-icon>save</v-icon>Save
              </v-btn>
              <v-btn color="error" @click="reset">Reset</v-btn>
            </v-card-actions>
          </v-form>
        </v-flex>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
import store from "../../store";
import commonservice from "../../shared/common.service";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
export default {
  components: { VueCropper },
  computed: {
    name: {
      get() {
        return this.$store.state.testimonials.entity.name;
      },
      set(val) {
        this.$store.commit("testimonials/SET_TESTIMONIALS_DATA", {
          key: "name",
          value: val
        });
      }
    },
    image: {
      get() {
        return this.$store.state.testimonials.entity.image;
      },
      set(val) {
        this.$store.commit("testimonials/SET_TESTIMONIALS_DATA", {
          key: "image",
          value: val
        });
      }
    },
    mainImage: {
      get() {
        return this.$store.state.testimonials.mainImage;
      },
      set(val) {
        this.$store.commit("testimonials/SET_MAIN_IMAGE", val);
      }
    },
    email: {
      get() {
        return this.$store.state.testimonials.entity.email;
      },
      set(val) {
        this.$store.commit("testimonials/SET_TESTIMONIALS_DATA", {
          key: "email",
          value: val
        });
      }
    },
    review: {
      get() {
        return this.$store.state.testimonials.entity.review;
      },
      set(val) {
        this.$store.commit("testimonials/SET_TESTIMONIALS_DATA", {
          key: "review",
          value: val
        });
      }
    },
    status: {
      get() {
        return this.$store.state.testimonials.entity.status;
      },
      set(val) {
        this.$store.commit("testimonials/SET_TESTIMONIALS_DATA", {
          key: "status",
          value: val
        });
      }
    },
    rating: {
      get() {
        return this.$store.state.testimonials.entity.rating;
      },
      set(val) {
        this.$store.commit("testimonials/SET_TESTIMONIALS_DATA", {
          key: "rating",
          value: val
        });
      }
    },
    statusList: {
      get() {
        return this.$store.state.testimonials.statusList;
      }
    },
    ratingList: {
      get() {
        return this.$store.state.testimonials.ratingList;
      }
    }
  },
  data() {
    return {
      pageTitle: "Add Testimonials",
      loading: false,
      menu: false,
      menu1: false,
      ratio: 1 / 1,
      showCrop: false
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.id) {
      store
        .dispatch("testimonials/setTestimonials", { id: to.params.id })
        .then(() => {
          next(p => {
            p.pageTitle = "Edit Testimonials";
          });
        });
    } else {
      next(p => {
        p.reset();
      });
    }
  },
  methods: {
    submit() {
      if (this.loading) return;
      // if (this.image == null) {
      //   commonservice.showErrorMessage("Please upload image");
      //   return;
      // }
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("testimonials/saveTestimonials")
            .then(
              () => {
                commonservice.showSuccessMessage(
                  "Testimonials saved successfully"
                );
                this.$router.push("/testimonials");
                this.loading = false;
              },
              () => {
                this.loading = false;
              }
            )
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    reset() {
      this.$store.commit("testimonials/RESET");
      setTimeout(() => {
        this.errors.clear();
      }, 10);
    },
    imagePicked() {
      this.$refs.ImageUploader.click();
    },
    crop() {
      var self = this;
      // get image data for post processing, e.g. upload or setting image src
      var cropIm = self.$refs.cropper.getCroppedCanvas().toDataURL();
      self.$store.commit("testimonials/SET_TESTIMONIALS_DATA", {
        key: "image",
        value: cropIm
      });
    },
    onImagePicked(event) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      var self = this;
      reader.onload = function() {
        self.$store.commit("testimonials/SET_MAIN_IMAGE", reader.result);
        self.$refs.cropper.replace(reader.result);
        self.showCrop = true;
      };
    }
  }
};
</script>
